// extracted by mini-css-extract-plugin
module.exports = {"quote":"_27INddCa","logo":"_3kf1jBAy","button":"_3MpUT6ve","logoContainer":"_2VX-LDBn","metaTerm":"_3iMpmjTd","metaDescription":"_220lGKAv"};